<form *ngIf="consentForm" [formGroup]="consentForm" (ngSubmit)="acceptConsent()">
  <div *ngIf="registerTitle" class="register-title mt-3">
    {{registerTitle}}
  </div>
  <div *ngIf="registerPeriod" class="register-period">
    Register period from {{registerPeriod}}
  </div>
  <div formArrayName="consentArray">
    <div [formGroup]="consent"
      class="my-3 p-3 rounded border bg-white shadow-sm"
      [ngClass]="{'border-danger': !(consent | formGroup).valid && (consent | formGroup).touched}"
      *ngFor="let consent of consentListFA.controls; let i = index;">
      
      <h6 class="text-left" id="consent-field-name-text-{{i}}">
        {{(consent | formGroup).controls.name.value}}
        <span class="tag-orange ml-2">Required</span>
      </h6>

      <div class="pre-line-text" id="consent-field-content-text-{{i}}" 
        [innerHTML]="(consent | formGroup).controls.content.value">
      </div>

      <hr class="consent-divider">

      <div *ngIf="(consent | formGroup).controls.isRequired.value">
        <input
          type="checkbox"
          formControlName="accept"
          class="form-checkbox"
          [id]="'consent-field-acknowledge-checkbox-' + i">
        <label
          [for]="'consent-field-acknowledge-checkbox-' + i">
          Acknowledge
        </label>
      </div>

      <div *ngIf="!(consent | formGroup).controls.isRequired.value">
        <input
          type="radio"
          formControlName="accept"
          [value]="true"
          class="form-radio"
          [id]="'consent-field-accept-radio-input-' + i">
        <label [for]="'consent-field-accept-radio-input-' + i">Accept</label>

        <input
          type="radio"
          formControlName="accept"
          [value]="false"
          class="form-radio ml-3"
          [id]="'consent-field-decline-radio-input-' + i">
        <label [for]="'consent-field-decline-radio-input-' + i">Decline</label>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button
      id="consent-next-button"
      class="btn btn-primary"
      type="submit"
      [disabled]="!allConsentChecked()">
      Next
    </button>
  </div>
</form>